// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1996":"ebfd19f56941cd14","4278":"04416e88d5480a6a","5246":"4e4038847bdc30bb","7098":"c62eb939fc024eaf","7473":"05b0fdb10b662d26"}[chunkId] + ".js";
};